import { Button, Input, List, message, Modal } from "antd";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getEmplApproveListByEmplSource } from "@/api/ebook";
import { ApprContacts, EmplApproveList } from "@/types/chat/State";
import "./index.less";

import { updateApprTeamContacts } from "@/api/chat";

import { setExternalContactsTipsTool } from "@/utils/chat/index";
import Item from "./Item";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import bus from "@/utils/bus";
import { TeamApplyStatus } from "@/types/chat/enum";

export interface contactsListInfo {
  userName: string; // 申请人
  gmtCreate: string; // 申请时间
  adminName?: string; // 审批人
  approveTime?: string; // 审核时间
  approveStatus: number; // 审核状态, 1:待审批, 2:通过, 3:驳回
  emplSource: string;
  approveId: string;
  rejectReason?: string; // 驳回原因
  loading: boolean;
  refuse: boolean;
}

const limit = 10;

function ApplyTeamContactsList() {
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const [t] = useTranslation("chat");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [ContactsList, setContactsList] = useState<contactsListInfo[]>([]);
  const [visible, setVisible] = useState(false);
  const getContactsList = async (page = 1) => {
    const param: EmplApproveList = {
      pageNo: page,
      emplSourceList: [12], // 固定值
      resourceId: "179993567195561984", // 固定值
      pageSize: limit // 每页数量
    };
    const [result, error] = await getEmplApproveListByEmplSource(param);

    if (error) {
      message.error(error);
      return;
    }
    // console.log(result, "result>ls");
    const { total, data: list } = result;

    setTotal(total);

    const newList: any = ContactsList.concat(list).map((item: any) => {
      return {
        ...item,
        refuse: false,
        loading: false
      };
    });

    setContactsList(newList);
  };
  useEffect(() => {
    if (visible) {
      getContactsList();
    }
  }, [visible]);
  useEffect(() => {
    const show = () => {
      setVisible(true);
    };
    bus.on("showApplyTeamContactsList", show);
    return () => {
      bus.off("showApplyTeamContactsList", show);
    };
  }, []);
  const handleAdd = useCallback(
    async (item: any, approveStatus: number, refusalCause?: string) => {
      item.loading = true;
      const param: ApprContacts = {
        lang: "zh_CN", // 固定
        approveId: item.approveId, // 审批记录id
        approveStatus: approveStatus, // 2: 通过, 3:驳回
        resourceId: "179993612791840768", // 固定
        rejectReason: refusalCause || "" // 驳回原因最大支持100个长度
      };

      const [result, error] = await updateApprTeamContacts(param);

      item.loading = false;

      if (error) {
        message.error(error);
        return;
      }

      const newContactsList: any = ContactsList.map((n: any) => {
        if (n.approveId === item.approveId) {
          n.approveStatus = approveStatus;
          n.refuse = false;
        }
        return n;
      });
      setContactsList(newContactsList);
      setExternalContactsTipsTool(result, t);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ContactsList]
  );

  function handleClose() {
    setVisible(false);
    setPage(1);
    setTotal(0);
    setContactsList([]);
  }
  function handleClouseRefuse(item: any, type: boolean) {
    const newList: any = ContactsList.map((n: any) => {
      if (item.approveId === n.approveId) {
        item.refuse = type;
      }
      return n;
    });
    setContactsList(newList);
    // setRefusalCause('');
  }

  const titleNode = useCallback(
    (item) => {
      return (
        <>
          <span>{item.userName} </span> 申请加入团队
        </>
      );
    },
    [t]
  );

  return (
    <Modal
      title={t("applicationList")}
      destroyOnClose
      centered={true}
      visible={visible}
      onCancel={() => {
        handleClose();
      }}
      footer={null}
      width="720px"
      bodyStyle={{ height: 580, overflow: "auto" }}
    >
      <div className="teams-applies">
        {ContactsList.length ? (
          ContactsList.map((item: any, key) => {
            return (
              <Item
                data={item}
                key={key}
                handleClouseRefuse={handleClouseRefuse}
                handleAdd={handleAdd}
                titleNode={titleNode(item)}
              />
            );
          })
        ) : (
          <p style={{ margin: "20px auto" }}>暂无数据</p>
        )}

        {page * limit < total ? (
          <p
            style={{ cursor: "pointer", textAlign: "center" }}
            onClick={() => {
              getContactsList(page + 1);
              setPage(page + 1);
            }}
          >
            {t("Load more")}
          </p>
        ) : (
          ""
        )}
      </div>
    </Modal>
  );
}

export default ApplyTeamContactsList;
